import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { ShoppingLink } from 'site-modules/shared/components/shopping-link/shopping-link';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';
import { LEASE_DEALS_PATH } from 'site-modules/shared/routes/lease-deals';

import './lease-deals-hidden-gems-link-chal-1.scss';

export const LeaseDealsHiddenGemsLinkChal1 = memo(props => {
  const { monthlyPayment, paymentMedian, className, make, model, year, parentCreativeId } = props;
  const CREATIVE_ID = 'oem_lease_deal';

  return (
    <ShoppingLink
      label={`${formatPriceString(monthlyPayment)}/mo lease found!`}
      description={`This exceptionally rare deal is ${formatPriceString(paymentMedian - monthlyPayment)} below typical`}
      to={LEASE_DEALS_PATH}
      className={classNames('lease-deals-hidden-gems-entry-chal-1 rounded-12', className)}
      descriptionClassName="medium text-cool-gray-30"
      arrowClassName="icon-arrow-right3 cool-gray-40"
      icon={
        <Image
          lazy
          ariaHidden
          source={SOURCES.STATIC}
          imageId="/icons/lease-deals-gem.svg"
          className="object-fit-cover me-1"
          width={28}
          height={24}
        />
      }
      styles={{ padding: '1.5rem' }}
      data-tracking-parent={parentCreativeId ? `${parentCreativeId}_${CREATIVE_ID}` : CREATIVE_ID}
      data-tracking-id="view_hidden_gems_lease_deals"
      data-tracking-value={`${formatPriceString(monthlyPayment)} - ${make} ${model} ${year}`}
    />
  );
});

LeaseDealsHiddenGemsLinkChal1.propTypes = {
  monthlyPayment: PropTypes.number.isRequired,
  paymentMedian: PropTypes.number.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  className: PropTypes.string,
  parentCreativeId: PropTypes.string,
};

LeaseDealsHiddenGemsLinkChal1.defaultProps = {
  className: '',
  parentCreativeId: '',
};

LeaseDealsHiddenGemsLinkChal1.displayName = 'LeaseDealsHiddenGemsLinkChal1';
